import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon from '@projeccions-pdc/react-icon';
import { Link } from 'react-router-dom';
import { isAdmin, isEditor } from '../../helpers';
import styles from './ToolsStyle';
import { isSmartphone } from '../../helpers';
import  { /*ToolsData*/ ToolsDataPerPlatformId }  from '../../ToolsList';
import AppContext from '../../AppContext';
import LocalizedStrings from '../Localization/localization';

class Tools extends Component {
    constructor(props) {
        super(props);
        this.state = {
            smartphoneView: undefined,
            platformId: new AppContext().getPlatformId(),
        };
    }

    handleSizeChange = (match) => {
        this.setState({ smartphoneView: match });
    }

    componentDidMount() {
        this.removeListener = isSmartphone((match) => this.handleSizeChange(match));
    }

    componentWillUnmount() {
        this.removeListener();
    }

    renderContent = (tile, iconSize) => {
        let iconElement = <Icon name={tile.iconElement} size={iconSize} primaryColor={'#fff'} />;
        // if (this.state.smartphoneView === true) {
            return (
                <div style={styles.toolsItem} >
                    <div style={{ ...(styles.toolAvatar), backgroundColor: tile.color }}>
                        {iconElement}
                    </div>
                    <div style={styles.description}>{LocalizedStrings[tile.title]}</div>
                </div>
            );
        // } else {
        //     return (
        //         <div style={styles.toolsItem} >
        //             <div style={{ ...(styles.toolAvatar), backgroundColor: tile.color }}>
        //                 {iconElement}
        //                 <div style={styles.toolTitle}>{LocalizedStrings[tile.title]}</div>
        //             </div>
        //             <div style={styles.description}>{LocalizedStrings[tile.description]}</div>
        //         </div>
        //     );
        // }
    }

    render() {
        let iconSize = '40px';
       

        let isAdminVar = isAdmin();
        let isEditorVar = isEditor();
        return (
            <div style={styles.container}>
                {ToolsDataPerPlatformId(this.state.platformId).map(tile => {
                    if (isAdminVar === false && tile.role === 'admin') {
                        return ('');
                    } else if (isAdminVar === false && isEditorVar === false && tile.role === 'adminoreditor') {
                        return ('');
                    } else if (this.props.isOnline !== true && tile.online === true) {
                        return ('');
                    } else {
                        if (tile.uri !== undefined) {
                            return (
                                <Link data-id={tile.title} data-type="charly-tool" key={tile.title} to={tile.uri}>
                                    {this.renderContent(tile, iconSize)}
                                </Link>
                            );
                        } else {
                            let Element = tile.element;
                            return (
                                <Element
                                    key={tile.title}
                                    data-id={tile.title}
                                    data-type="charly-tool"
                                    smartphoneView={this.state.smartphoneView}
                                    iconSize={iconSize} />
                            );
                        }
                    }
                })}
            </div>
        );
    }
}
Tools.propTypes = {
    isOnline: PropTypes.bool,
};

export default Tools;